import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import ReactCreatable from 'react-select/creatable'
import EmailPasteableInput from './EmailPasteableInput'
import DropdownIndicator from '../Select/DropdownIndicator'
import { SELECT_STYLES, SELECT_THEME } from '../Select/Select'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u
const SEPARATOR_REGEX = /[\s,;]+/u

const toOption = email => ({ value: email, label: email })

const formatCreate = input => `Ajouter "${input}"`

const isValidNewEmail = input => EMAIL_REGEX.test(input.trim())

const renderNoOptions = () => null

const splitEmails = text => text.split(SEPARATOR_REGEX).map(item => item.trim()).filter(Boolean)

const CUSTOM_COMPONENTS = { DropdownIndicator, Input: EmailPasteableInput }

const EmailsTagInput = ({
  emails,
  onChange,
  placeholder = 'email@exemple.fr',
  menuPortalTarget = null,
  ...rest
}) => {
  const value = useMemo(() => emails.map(toOption), [emails])

  const handleChange = useCallback(options => {
    onChange((options || []).map(option => option.value))
  }, [onChange])

  const handleCreate = useCallback(input => {
    const trimmed = input.trim()
    if (emails.includes(trimmed))
      return
    onChange([...emails, trimmed])
  }, [emails, onChange])

  const handlePaste = useCallback(event => {
    const text = event.clipboardData.getData('text')
    if (!text)
      return
    // Only intercept pastes that contain a separator (multi-email payload).
    // Single-token pastes go through the normal create flow on Enter.
    if (!SEPARATOR_REGEX.test(text))
      return
    const validEmails = splitEmails(text).filter(item => EMAIL_REGEX.test(item))
    if (validEmails.length === 0)
      return
    event.preventDefault()
    const fresh = validEmails.filter(email => !emails.includes(email))
    if (fresh.length === 0)
      return
    onChange([...emails, ...fresh])
  }, [emails, onChange])

  return (
    <ReactCreatable
      {...rest}
      components={CUSTOM_COMPONENTS}
      formatCreateLabel={formatCreate}
      isValidNewOption={isValidNewEmail}
      menuPortalTarget={menuPortalTarget}
      noOptionsMessage={renderNoOptions}
      options={[]}
      placeholder={placeholder}
      styles={SELECT_STYLES}
      theme={SELECT_THEME}
      value={value}
      isMulti
      onChange={handleChange}
      onCreateOption={handleCreate}
      onPasteEmails={handlePaste}
    />
  )
}

EmailsTagInput.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  menuPortalTarget: PropTypes.instanceOf(Element),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}

EmailsTagInput.defaultProps = {
  menuPortalTarget: null,
  placeholder: 'email@exemple.fr'
}

export default EmailsTagInput
